export default __webpack_public_path__ + "static/media/404.c6b41d88.png";